import React from "react"
import styled from "@emotion/styled"

import PublicLayout from "../public-layout"
import SignUpFox from "../ui/images/sign-up-fox"
import SignUpContentV3 from "./sign-up-content/index-v3"

const Container = styled.section`
  display: flex;
  min-height: 100%;
`

const SignUpV3 = () => (
  <PublicLayout>
    <Container>
      <SignUpFox />
      <SignUpContentV3 />
    </Container>
  </PublicLayout>
)

export default SignUpV3
